export default "__VITE_ASSET__c0084f6d__"